export default [
  'accountsPayable',
  'installmentOther',
  'banks',
  'other',
  'unpaidTaxes',
  'contingents',
];



// WEBPACK FOOTER //
// ./src/vuex/modules/profile/resources/finances/liabilityKeys.js